import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyCRz_mGNS1yRe3uX4sqdnqOCvDMJjSRMcU',
  authDomain: 'norppa-cw.firebaseapp.com',
  projectId: 'norppa-cw',
  storageBucket: 'norppa-cw.firebasestorage.app',
  messagingSenderId: '49222223466',
  appId: '1:49222223466:web:df939e9b45b4704b7dac13'
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);